import { render, staticRenderFns } from "./CreateSub.vue?vue&type=template&id=56501cf4&scoped=true&"
import script from "./CreateSub.vue?vue&type=script&lang=ts&"
export * from "./CreateSub.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSub.vue?vue&type=style&index=0&id=56501cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56501cf4",
  null
  
)

export default component.exports